import { useEmail } from '@/state/email';
import { Inbox } from './Inbox';
import { EmailView } from './EmailView';

export function Email() {
  const selectedId = useEmail((s) => s.selectedId);
  return (
    <div className="flex h-full flex-col bg-[var(--bg-deep)]">
      {selectedId ? <EmailView emailId={selectedId} /> : <Inbox />}
    </div>
  );
}
